import * as React from "react";

import ImageHolder from "common/components/imageHolder";

const classStyles = require("./squareStackedImage.scss");

interface IProps {
  width: number;
  height: number;
  src?: string;
  color?: string;
  title?: string;
  alt?: string;
  className?: string;
  wrapperStyles?: React.CSSProperties;
  imgStyles?: React.CSSProperties;
}

const SquareStackedImage = ({
  width,
  height,
  src,
  color,
  title,
  className,
  wrapperStyles,
  imgStyles,
  alt = src,
}: IProps) => {
  const styles = {
    width: width + 2,
    height: height + 2,
    bottomMargin: 2,
  };

  const imageStyles = {
    borderRadius: 8,
    overflow: "hidden",
    border: "solid 1px rgba(0, 0, 0, 0.05)",
  };

  const borderStyles1 = {
    width: width - 8,
  };

  const borderStyles2 = {
    width: width - 16,
  };

  const finalWrapperStyles = { ...styles, ...wrapperStyles };
  const finalImgStyles = { ...imageStyles, ...imgStyles };

  let imagePlace: React.ReactNode | null = null;
  if (src) {
    imagePlace = (
      <ImageHolder
        style={finalImgStyles}
        src={src}
        alt={alt}
        width="100%"
        height="100%"
      />
    );
  } else {
    imagePlace = (
      <div
        style={{ ...finalImgStyles, backgroundColor: color }}
        className={classStyles.charWrapper}
      >
        <span className={classStyles.thumbChar}>
          {title ? title.substr(0, 1) : ""}
        </span>
      </div>
    );
  }

  return (
    <div className={className} style={finalWrapperStyles}>
      {imagePlace}
      <div className={classStyles.border1} style={borderStyles1} />
      <div className={classStyles.border2} style={borderStyles2} />
    </div>
  );
};

export default SquareStackedImage;
